var React = require('react');

function SliderArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"slider-arrow-right__stroke","d":"m2 1 11 18-11 18","fill":"none","stroke":"#fff","strokeWidth":"5"}));
}

SliderArrowRight.defaultProps = {"className":"slider-arrow-right","height":"38","viewBox":"0 0 16 38","width":"16"};

module.exports = SliderArrowRight;

SliderArrowRight.default = SliderArrowRight;
